import { ChartState } from './types'

export const state: ChartState = {
  chartCollections: [],
  chartData: null,
}
